











import Vue from 'vue'
import { AccountType } from '@/types/generated/graphql'
import XDropdown, {
  OptionEntry,
} from '@/components/atoms/Dropdown/XDropdown.vue'
import formatEnum from '@/plugins/filters/formatEnum'

type Data = {
  options: Array<OptionEntry<AccountType>>
}

type Props = {
  value: string
  rules?: string | Record<string, boolean>
}

export default Vue.extend<Data, {}, {}, Props>({
  name: 'BankAccountCreate',
  components: {
    XDropdown,
  },
  props: {
    value: {
      type: String,
    },
    rules: {
      type: [String, Object],
      required: false,
    },
  },
  data() {
    return {
      options: [
        {
          value: AccountType.Savings,
          label: formatEnum(AccountType.Savings, 'accountType'),
        },
        {
          value: AccountType.Current,
          label: formatEnum(AccountType.Current, 'accountType'),
        },
        {
          value: AccountType.Others,
          label: formatEnum(AccountType.Others, 'accountType'),
        },
      ],
    }
  },
})
